import { render, staticRenderFns } from "./scope.vue?vue&type=template&id=4d4b750a&scoped=true"
import script from "./scope.vue?vue&type=script&lang=js"
export * from "./scope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b750a",
  null
  
)

export default component.exports